import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as api from '../../shared/api/apihandler';
import { AssetCustomField } from 'app/shared/models/assets.models';

@Component({
  selector: 'asset-custom-field',
  templateUrl: './asset-custom-field.component.html',
  styleUrls: ['./asset-custom-field.component.css']
})
export class AssetCustomFieldComponent implements OnInit, OnChanges, OnDestroy {

  @Input() customField!:AssetCustomField;
  @Input() value!: string;
  @Input() editable: boolean = false;
  @Input() assetId!: string;
  @Output() valueChange = new EventEmitter();
  @Output() update = new EventEmitter();
  @Output() customFieldChange = new EventEmitter<AssetCustomField>();

  showChoices: boolean = false;
  editChoice?:string;
  editName: boolean = false;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.customField.typeId == '27e3ae4d-3a11-44be-884b-1e264176049e') {
      document.removeEventListener('click', (e) => this.click(e));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.customField && !!changes.customField.currentValue && this.customField.typeId == '27e3ae4d-3a11-44be-884b-1e264176049e') {
      document.addEventListener('click', (e) => this.click(e))
    }
  }

  addOptionToTemplate() {
    if (!this.customField.template) this.customField.template = [];
    else{
      switch(typeof this.customField.template) {
        case 'string' : {
          // The template should always be an array or null
          break
        }
        case 'object': {
          this.customField.template.push(this.customField.template.length.toString());

        }
      }

    }
    console.log(this.customField);
  }

  choicesToText() {
    if (!this.customField.template) this.customField.template = [];
    else{
      switch(typeof this.customField.template) {
        case 'string' : {
          this.editChoice = this.customField.template;
          break
        }
        case 'object': {
          this.editChoice = this.customField.template.join('\n');

        }
      }
    }
    
  }

  textToChoices() {
    this.customField.template = !!this.editChoice ? this.editChoice.split('\n').filter(x => !!x).map(x => x.trim()) : [];
    this.customFieldChange.emit(this.customField);
    this.updateCustomField();
  }

  eyeCheck() {
    if (!!this.customField.template && this.customField.template.length > 0 && this.customField.template.includes('showOnAssetSite')) {
      return true;
    }
    return false;
  }

  sortEditChoice() {
    this.editChoice = this.editChoice ? this.editChoice.split('\n').sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1).join('\n') : undefined;
  }

  textareaClick(e: MouseEvent) {
    e.preventDefault();
    let t = e.target as HTMLTextAreaElement;
    let selectText = (e.target! as HTMLTextAreaElement).value.split('\n')[(e.target! as HTMLTextAreaElement).value.slice(0, t.selectionStart).split('\n').length - 1];
    t.selectionStart = t.value.indexOf(selectText);
    t.selectionEnd = t.selectionStart + selectText.length + 1;
  }

  textToCase(typecase: string) {
    switch (typecase) {
      case 'upper': {
        this.editChoice = !!this.editChoice ? this.editChoice.toUpperCase() : '';
        break;
      }
      case 'title': {
        this.editChoice = !!this.editChoice ? this.editChoice.split('\n').map(x => x[0].toUpperCase() + x.slice(1).toLowerCase()).join('\n') : '';
        break;
      }
      case 'lower': {
        this.editChoice = !!this.editChoice ? this.editChoice.toLowerCase() : '';
        break;
      }
    }
  }

  openOptionsList(e: any) {
    //console.log('opening options', e);
    let a = document.getElementById('customFieldsOptionsList' + this.customField.id);
    if(!!a) a.style.display = 'block';
    setTimeout(() => {
      this.showChoices = true;
    }, 100);
  }

  closeOptionsList() {
    let a = document.getElementById('customFieldsOptionsList' + this.customField.id);
    if(!!a) a.style.display = 'none';
    this.showChoices = false;
  }

  makeNameEditable() {
    if (!!this.editable) {
      this.editName = true;
      setTimeout(() => {
        document.getElementById('fieldName' + this.customField.id)!.focus();
      }, 50);
    }
  }

  updateCustomField() {
    console.log(this.customField)
    let bodyData = {
      fieldId: this.customField.id,
      typeId: this.customField.typeId,
      assetId: this.assetId
    };
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    this.http.post(api.jubloApi + 'api/Assets/UpdateCustomField/', bodyData, { headers }).subscribe({next:() => this.editName = false});
  }

  click(e: MouseEvent) {
    if (this.showChoices) {
      setTimeout(() => {
        this.closeOptionsList();
      }, 200);
    }
  }

  autoGrow(e: MouseEvent) {
    if(!!e){
      let t = e.target! as HTMLElement;
      t.style.height = '5px';
      if (t.scrollHeight + 20 < 300) {
        t.style.height = (t.scrollHeight + 20) + 'px';
      }
      else {
        t.style.height = '300px';
      }
    }
  }

  autoShrink(e: Event) {
    let t = e.target! as HTMLElement;
    t.style.height = '40px';
  }

  changeValue(ev?:Event) {
    if(ev && this.customField.typeId == 'f21df8df-a7eb-43b9-a25b-99704d70c96c') this.value = (ev.target as HTMLInputElement).checked.toString();
    console.log(ev)
    //console.log(JSON.parse(JSON.stringify(this.customField)), this.value);
    this.valueChange.emit(this.value);
    this.update.emit({ ...this.customField, value: this.value });
  }
}
